// DashBoardUserBehaviourView.tsx
import { Button, DatePicker, Select, Space } from "antd";
import { ContentTopBar } from "components";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import timezone from "dayjs/plugin/timezone";
import { UserBehaviorGraphView } from "features/dashboard/components/user-behaviour/user-behaviour-graph";
import { Fragment, useState } from "react";

dayjs.extend(customParseFormat);
dayjs.extend(timezone);

export const DashBoardUserBehaviourView = () => {
  const { RangePicker } = DatePicker;
  const currentDate = dayjs();

  // Default date range to today
  const [dateRange, setDateRange] = useState<[dayjs.Dayjs, dayjs.Dayjs] | null>(
    [currentDate, currentDate]
  );

  // State for month and year select
  const [selectedMonth, setSelectedMonth] = useState<string>(
    dayjs().format("MMM")
  );
  const [selectedYear, setSelectedYear] = useState<number>(dayjs().year());

  const months = [
    { label: "All", value: "All" }, // Changed from null to 'All' for consistency
    ...dayjs.monthsShort().map((m) => ({ label: m, value: m })),
  ];

  const currentYear = dayjs().year();
  const years = [];
  for (let y = currentYear - 10; y <= currentYear + 5; y++) {
    years.push({ label: y.toString(), value: y });
  }

  // State to track applied filters
  const [appliedFilters, setAppliedFilters] = useState<{
    selectedMonth: string;
    selectedYear: number;
    dateRange: [dayjs.Dayjs, dayjs.Dayjs] | null;
  }>({
    selectedMonth,
    selectedYear,
    dateRange,
  });

  return (
    <Fragment>
      <div className="facily_head">
        <ContentTopBar title={"User Behavior"} />
        <Space style={{ marginBottom: 16 }} className="filter_srch">
          <Select
            options={months}
            value={selectedMonth}
            onChange={(value) => {
              setSelectedMonth(value);
              if (value !== "All") {
                setDateRange(null); // Clear range picker when selecting a specific month
              }
            }}
            style={{ width: 120 }}
            placeholder="Select Month"
            allowClear
          />
          <Select
            options={years}
            value={selectedYear}
            onChange={(value) => {
              setSelectedYear(value);
              setDateRange(null); // Clear range picker when selecting a specific year
            }}
            style={{ width: 120 }}
            placeholder="Select Year"
          />
          <RangePicker
            value={dateRange}
            onChange={(dates) =>
              setDateRange(dates as [dayjs.Dayjs, dayjs.Dayjs])
            }
            allowClear
          />
          <div className="filt_btn" style={{ display: "flex", gap: "10px" }}>
            <Button
              type="primary"
              onClick={() =>
                setAppliedFilters({
                  selectedMonth,
                  selectedYear,
                  dateRange,
                })
              }
            >
              Filter
            </Button>
            <Button
              onClick={() => {
                const now = dayjs();
                const currentMonth = dayjs().format("MMM");
                const currentYear1 = dayjs().year();
                setSelectedMonth(currentMonth);
                setSelectedYear(currentYear1);
                setDateRange([now, now]);
                setAppliedFilters({
                  selectedMonth: currentMonth,
                  selectedYear: currentYear1,
                  dateRange: [now, now],
                });
              }}
            >
              Cancel
            </Button>
          </div>
        </Space>
        <UserBehaviorGraphView
          selectedYear={appliedFilters.selectedYear}
          selectedMonth={appliedFilters.selectedMonth}
          dateRange={appliedFilters.dateRange}
        />
      </div>
    </Fragment>
  );
};
